export function getRequiredFieldErrors(
  formData: FormData,
  fields: string[],
  message: string
) {
  const errors: Record<string, string> = {};

  fields.forEach((field) => {
    const value = formData.get(field);
    if (typeof value !== "string" || value.trim() === "") {
      errors[field] = message;
    }
  });

  return errors;
}
